import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import BusinessUnitsBody from './BusinessUnitsBody.js';

const BusinessUnits = ReactRouterDOM.withRouter(function () {
  const { setError } = useAppContext();

  return (
    <div>
      <div className="p-1">
        <div className="border bg-light">
          <div className="p-2 fs-6">
            <BusinessUnitsBody />
          </div>
        </div>
      </div>
    </div>
  );
})

export default BusinessUnits;
